import React from 'react';
import config from '../../config';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { navigateToExternal } from '../../core/util';
import { navigateToLogin } from '../../flows/shared/utils';
import styles from './styles.css';

const LoginCTA = ({ authenticated }) => {
  const navigateToCurrNASURJ = () =>
    navigateToExternal(
      `${config(
        'returnUrlPrefix'
      )}personal-investing/new-account/setup/return-journey/email`
    );

  return (
    <div className="login-cta">
      {authenticated ? (
        <div className="logged-in-cta">
          <span>
            You&apos;re logged in, so we&apos;ve prefilled some of your
            information.{' '}
          </span>
          <span className="navigate-btn">
            <MFBeaconButton
              type="button"
              id="existingUserFinishApplication"
              data-name="finishApplicationBtn"
              className="override-beacon-button-padding"
              onClick={navigateToCurrNASURJ}
              onKeyPress={navigateToCurrNASURJ}
              variant="tertiary"
              label="Finish an application"
            />
          </span>{' '}
          <span>you&apos;ve already started.</span>
        </div>
      ) : (
        <div className="logged-out-cta">
          <span>Already a customer? </span>
          <span className="login-btn">
            <MFBeaconButton
              type="button"
              id="newUserLoginLink"
              data-name="newUserLoginBtn"
              onClick={navigateToLogin}
              onKeyPress={navigateToLogin}
              variant="tertiary"
              label="Log in"
            />
          </span>{' '}
          <span>
            for a faster experience and access to exclusive benefits. Or{' '}
          </span>
          <span className="navigate-btn">
            <MFBeaconButton
              type="button"
              id="newUserFinishApplication"
              data-name="newUserFinishApplicationBtn"
              onClick={navigateToCurrNASURJ}
              onKeyPress={navigateToCurrNASURJ}
              variant="tertiary"
              label="finish an application"
            />
          </span>{' '}
          <span>you&apos;ve already started.</span>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

export default LoginCTA;
